module.exports = __webpack_public_path__ + "img/businessman-collecting.caa09e05.jpeg";